import { useApiTestingLanguage } from './useApiTestingLanguage';
/**
 * TestEmptyState Component
 * 
 * Displays the empty state UI when no API tests exist.
 * Provides options to create tests with AI or manually.
 * Extracted from APITesting.js for better maintainability.
 */

import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { 
  Server,
  Brain,
  Plus
} from 'lucide-react';

export const TestEmptyState = ({
  onAiGenerate,
  onManualCreate
}) => {
  const { t } = useApiTestingLanguage();
  return (
    <Card className="p-12 text-center" data-testid="test-empty-state">
      <Server className="h-16 w-16 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {t("No API tests created yet")}
      </h3>
      <p className="text-gray-600 mb-6">
        {t("Start by creating your first API test with AI or manually")}
      </p>
      <div className="flex justify-center space-x-4">
        <Button 
          onClick={onAiGenerate}
          className="bg-gradient-to-r from-purple-600 to-blue-600"
          data-testid="btn-ai-generate-empty"
        >
          <Brain className="h-4 w-4 mr-2" />
          {t("AI Generate")}
        </Button>
        <Button 
          onClick={onManualCreate}
          variant="outline"
          data-testid="btn-manual-create-empty"
        >
          <Plus className="h-4 w-4 mr-2" />
          {t("Manual Create")}
        </Button>
      </div>
    </Card>
  );
};
